import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import config from "../config";
import Icon from "../sections/MUI/Icon";
import axios from "axios";
import Field from "../sections/MUI/Field";
import Checks from "../sections/MUI/Checks";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";
import Modal from "../sections/MUI/Modal";
import req from "../req";

const perArr = [
    {t: "داشبورد", v: "dashboard"},
    {t: "تنظیمات", v: "settings"},
    {t: "کاربران", v: "users"},
    {t: "تسهیلات", v: "facilities"},
    {t: "خدمات", v: "services"},
    {t: "سفارشات", v: "orders"},
    {t: "ارسال پیامک", v: "sms"},
    {t: "فضای ابری", v: "storage"},
    {t: "پرداخت ها", v: "payments"},
    {t: "درگاه پرداخت", v: "gateway"},
    {t: "استعلام", v: "estelam"},
    {t: "بلک لیست", v: "blacklist"},
    {t: "مدیران", v: "admins"}
]

class Admins extends Component {

    state = {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        permissions: [],

        boxAdd: false,
        admins: [],

        editIndex: -1
    };


    componentDidMount() {
        config.scrollTop();
        this.getAdmins();
    }

    getAdmins() {
        req.get(`/admins`)
            .then(r => {
                this.setState({admins: r});
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    submit() {
        const {firstName, lastName, phoneNumber, permissions} = this.state;
        if (firstName !== "" && lastName !== "" && phoneNumber !== "") {

            toast.info("در حال ثبت ...");

            req.post(`/admin`, {
                firstName,
                lastName,
                phoneNumber,
                permissions
            })
                .then(r => {
                    toast.success("با موفقیت ثبت شد");
                    this.getAdmins();
                    this.setState({boxAdd: false});
                })
                .catch(err => {
                    config.handleError(err);
                });
        } else {
            toast.error("همه فیلد ها را وارد کنید!")
        }

    }

    edit() {
        const {editIndex, admins} = this.state;

        const {id, firstName, lastName, phoneNumber, permissions} = admins[editIndex];

        if (firstName !== "" && lastName !== "" && phoneNumber !== "") {
            toast.info("در حال ویرایش ...")
            req.put(`/admin`, {
                id,
                firstName,
                lastName,
                phoneNumber,
                permissions
            })
                .then(r => {
                    toast.success("با موفقیت ویرایش شد");
                    this.setState({
                        editIndex: -1
                    });
                    this.getAdmins();

                })
                .catch(err => {
                    config.handleError(err);
                });
        } else {
            toast.error("همه فیلد ها را وارد کنید")
        }
    }

    handleInputChange(name, value) {
        let {admins, editIndex} = this.state;
        admins[editIndex][name] = value;
        this.setState({
            admins
        });
    }

    delete(id) {
        toast.info("در حال حذف ...")
        req.delete(`/admin?id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد");
                this.getAdmins();
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    render() {
        const {admins, firstName, lastName, phoneNumber, permissions, boxAdd, editIndex} = this.state;
        return (
            <div className="admins">
                {editIndex !== -1 ?
                    <Modal icon="edit"
                           onCloseClick={() => this.setState({editIndex: -1})}
                           display={editIndex !== -1}
                           title="ویرایش">
                        <div className="row justify-content-center">
                            <div className="col-md-4">
                                <Field
                                    label="نام"
                                    name="firstName"
                                    value={admins[editIndex].firstName}
                                    onChange={(name, value) => this.handleInputChange(name, value)}/>
                            </div>
                            <div className="col-md-4">
                                <Field
                                    label="نام خانوادگی"
                                    name="lastName"
                                    value={admins[editIndex].lastName}
                                    onChange={(name, value) => this.handleInputChange(name, value)}/>

                            </div>
                            <div className="col-md-4">
                                <Field
                                    label="شماره موبایل"
                                    name="phoneNumber"
                                    maxLength={13}
                                    value={admins[editIndex].phoneNumber}
                                    onChange={(name, value) => this.handleInputChange(name, value)}/>
                            </div>
                            <div className="col-12">
                                <p style={{
                                    color: "#545454",
                                    textAlign: "center",
                                    fontSize: "11pt"
                                }}>اگر هیچ کدام از دسترسی ها را تیک نزنید یعنی همه دسترسی ها را می دهید.</p>
                                <Checks
                                    label="سطح دسترسی"
                                    value={admins[editIndex].permissions}
                                    onChange={(name, value) => this.handleInputChange(name, value)}
                                    name="permissions"
                                    options={perArr}/>
                            </div>
                            <div className="col-md-5">
                                <Button icon="edit" submit={false}
                                        onClick={() => this.edit()}>ویرایش</Button>
                            </div>
                        </div>
                    </Modal>
                    : null
                }

                <Back {...this.props}/>
                <div className="new">
                    <div className="row">
                        <div className="col-md-4">
                            <Button submit={false} icon="plus" backgroundColor="#1565C0"
                                    onClick={() => this.setState({boxAdd: !boxAdd})}>ثبت کردن</Button>
                        </div>
                    </div>
                    {
                        boxAdd ?
                            <div className="row">
                                <div className="col-md-4">
                                    <Field name="firstName"
                                           label="نام"
                                           value={firstName}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-md-4">
                                    <Field name="lastName"
                                           label="نام خانوادگی"
                                           value={lastName}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-md-4">
                                    <Field name="phoneNumber"
                                           label="شماره موبایل"
                                           maxLength={13}
                                           value={phoneNumber}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-12">
                                    <p style={{
                                        color: "#545454",
                                        textAlign: "center",
                                        fontSize: "11pt"
                                    }}>اگر هیچ کدام از دسترسی ها را تیک نزنید یعنی همه دسترسی ها را می دهید.</p>
                                    <Checks
                                        label="سطح دسترسی"
                                        value={permissions}
                                        onChange={(name, value) => this.setState({[name]: value})}
                                        name="permissions"
                                        options={perArr}/>

                                    <div className="row justify-content-center">
                                        <div className="col-md-4">
                                            <Button submit={false} icon="plus" onClick={() => this.submit()}>ثبت
                                                مدیر</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null
                    }
                </div>

                <br/>
                <div className="list">
                    {admins.map((a, i) =>
                        <article key={"admin" + i}>
                            <div className="row">
                                <div className="col-auto">
                                    <p className="full-name"><span>{a.firstName}</span>&nbsp;
                                        <span>{a.lastName}&nbsp;{a.phoneNumber === this.props.phoneNumber ? "(شما)" : ""}</span>
                                    </p>
                                </div>
                                <div className="col">
                                    <div className="phone-number">{a.phoneNumber}</div>
                                </div>

                                <div className="col-auto">
                                    <Icon i="edit" className="edit-icon" onClick={() => this.setState({editIndex: i})}/>
                                    <Icon i="trash" className="delete-icon"
                                          onDoubleClick={() => this.delete(a.id)}/>
                                </div>
                            </div>
                        </article>
                    )}
                </div>
            </div>
        );
    }
}

export default gpn(Admins);